import { Component, Input, OnChanges, inject, input, model, OnInit, output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';
import { ComponentModeEnum } from 'src/app/shared/enums/component-mode.enum';
import { DestinationStatus } from 'src/app/shared/enums/destination-status.enum';
import { CountryService } from '../../../services';
import { ICountry } from '../../../models/country.model';

@Component({
  selector: 'app-add-destination-form',
  templateUrl: './add-destination-form.component.html',
  styleUrls: ['./add-destination-form.component.scss'],
  standalone: false,
})
export class AddDestinationFormComponent implements OnChanges, OnInit {
  translate = inject(TranslateService);
  countryService = inject(CountryService);

  _mode: string;
  @Input() set mode(mode: string) {
    this._mode = mode;
  }

  get mode(): string {
    return this._mode;
  }
  componentModeEnum = ComponentModeEnum;
  readonly destinationFormGroup = input<FormGroup>(undefined);
  readonly length = input<number>(undefined);
  readonly isRoundTrip = model<boolean>(undefined);
  readonly isAdmin = input<boolean>(undefined);
  readonly roundTrip = output<any>();
  readonly deleteDestination = output<void>();
  travelForm: FormGroup;
  minDate: Date;
  returnDate: Date;
  formSubmitted = false;
  allCountries: ICountry[];

  ngOnInit(): void {
    this.countryService.getAllCountries().subscribe((data) => {
      this.allCountries = data;
    });
  }

  ngOnChanges(): void {
    if (this.mode != ComponentModeEnum.ADD) {
      this.minDate = this.destinationFormGroup().controls.departureDate.value;
      this.destinationFormGroup().valueChanges.subscribe(() => {
        const destinationFormGroup = this.destinationFormGroup();
        if (
          destinationFormGroup.controls.status.value !== DestinationStatus.MODIFIED &&
          destinationFormGroup.controls.status.value !== DestinationStatus.NEW
        ) {
          destinationFormGroup.controls.status.setValue(DestinationStatus.MODIFIED);
        }
      });
    }
  }

  getStartDate(event: MatDatepickerInputEvent<Date>) {
    this.minDate = event.value;

    this.destinationFormGroup().controls.returnDate.enable();
    if (!this.minDate || this.minDate > this.destinationFormGroup().controls.returnDate.value) {
      this.destinationFormGroup().controls.returnDate.setValue(null);
    }
  }

  public getErrorMessage(inputName?: string): string {
    if (inputName === 'radio-buttons') {
      return this.translate.instant('USER.REIMBURSEMENT_REQUESTS.ROUNDTRIP_REQUIRED');
    }
    {
      return this.translate.instant('USER.TRAVEL_REQUESTS.DESTINATION_REQUIRED');
    }
  }

  emitRoundTripChange(value: boolean) {
    this.roundTrip.emit(value);
  }

  deleteRow() {
    this.deleteDestination.emit();
  }
}
